import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';

import styles from './DailyNews.module.css';
import { useFeed, Item, useRevolveAd } from '../stories/TopStories.hooks';
import { Loading } from '../../../components/loading/Loading';

const FEED_URL = 'https://www.pw.org/daily_news/feed';

const DATE_FORMAT = 'MMMM dd, yyyy, hh:mm a';

export const DailyNews = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { feed, isLoading } = useFeed(FEED_URL);
	useEffect(() => {
		const updatedSearchParams = new URLSearchParams(
			searchParams.toString(),
		);
		updatedSearchParams.set('section', 'daily-news');
		setSearchParams(updatedSearchParams.toString());
	}, []);
	useEffect(() => {
		if (isLoading) {
			return;
		}
		if (!feed) {
			return;
		}
		setTimeout(() => {
			const links = document.querySelectorAll('#feed a');
			if (!links) {
				return;
			}

			links.forEach((e: any) => (e.target = '_blank'));
		}, 1000);
	}, [isLoading, feed]);

	const classNames = [styles['feed-container']];
	if (isLoading) {
		classNames.push(styles['loading']);
	}

	return (
		<section className={styles['daily-news']}>
			<h1>Daily News</h1>
			<h2>
				We scan the headlines to deliver
				<br />
				the news writers need.
			</h2>
			<div className={classNames.join(' ')}>
				{isLoading ? (
					<div className={styles['loading-container']}>
						<Loading />
					</div>
				) : (
					<div id="feed" className={styles['feed']}>
						{feed
							.map((item: Item, i: number) => (
								<FeedItem key={i} {...item} index={i} />
							))
							.reduce(reduceBanner, [])}
					</div>
				)}
				<footer>
					Discover more at{' '}
					<a
						href="https://www.pw.org"
						rel="noreferrer"
						target="_blank"
					>
						pw.org
					</a>
				</footer>
			</div>
		</section>
	);
};

function reduceBanner(acc: Array<any>, item: any, i: number): Array<any> {
	acc.push(item);
	if (i === 2) {
		acc.push(
			<Banner
				key={`0-${i}`}
				id="fbf717dc1969dc79e517b3994cd0df44"
				zone={66}
				ad="ADVERTISEMENT"
			/>,
		);
	}

	if (i === 5) {
		acc.push(
			<Banner
				key={`0-${i}`}
				id="fbf717dc1969dc79e517b3994cd0df44"
				zone={63}
				ad="ADVERTISEMENT"
			/>,
		);
	}

	return acc;
}

function Banner({ id, zone, ad }: { id: string; zone: number; ad?: string }) {
	const ref = useRef<any>();
	useRevolveAd(ref);
	return (
		<div ref={ref} className={styles['banner']}>
			<div>
				<div className={styles['ins-wrapper']}>
					<ins data-revive-zoneid={zone} data-revive-id={id}></ins>
				</div>
				{ref && ad ? <div className={styles['ad']}>{ad}</div> : null}
			</div>
		</div>
	);
}

const FeedItem = ({ description, index, pubDate }: Item) => {
	return (
		// eslint-disable-line jsx-a11y/no-static-element-interactions
		// eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
		<div className={styles['feed-item-container']} data-index={index}>
			<div className={styles['feed-item']}>
				<div className={styles['title']}>
					<h3>
						{pubDate
							? DateTime.fromJSDate(pubDate).toFormat(DATE_FORMAT)
							: null}
					</h3>
				</div>
				<div className={styles['content']}>
					<div
						dangerouslySetInnerHTML={{ __html: description }}
					></div>
				</div>
			</div>
		</div>
	);
};
